import { gql } from "graphql-tag";
import { responseField } from "../../../base.graphql";

export const userFields = `
id
uniqueId
firstName
lastName
email
phone
photo
accountType
isActive
createdDate
role{
        id
        uniqueId
        roleName
}
warehouses {
                warehouseName
                warehouseUniqueId
            }
`;

export const GET_ALL_USER = gql`
  query getAllUsers($filtering: ProfileFilteringObject) {
    getAllUsers(filtering: $filtering) {
      response {
        ${responseField}
      }
      data {
        ${userFields}
      }
    }
  }`;

export const GET_USER_PROFILE = gql`
  query getUserProfile($uniqueId: String!) {
    getUserProfile(uniqueId: $uniqueId) {
      response {
        ${responseField}
      }
      data {
        ${userFields}
      }
    }
  }`;

export const CREATE_USER_MUTATION = gql`
  mutation createUsersMutation($input: ProfileInputObject!) {
    createUsersMutation(input: $input) {
      response {
        ${responseField}
      }
      data {
        ${userFields}
      }
    }
  }`;

export const UPDATE_USER_MUTATION = gql`
  mutation updateUsersMutation($input: ProfileInputObject!) {
    updateUsersMutation(input: $input) {
      response {
        ${responseField}
      }
      data {
        ${userFields}
      }
    }
  }`;
  export const UPDATE_USER_PROFILE_MUTATION = gql`
  mutation UpdateUserProfileMutation($input: UpdateMyProfileInputObject!) {
    updateUserProfileMutation(input: $input) {
      response {
        ${responseField}
      }
      data {
        ${userFields}
      }
    }
  }`;

export const DELETE_USER_MUTATION = gql`
mutation DeleteUserMutation($uniqueId: String!) {
  deleteUsersMutation(uniqueId: $uniqueId) {
    response {
      id
      status
      code
      message
    }
  }
}`;

export const SET_USER_PASSWORD_MUTATION = gql`
  mutation SetUserPasswordMutation($input: ActivateUserInputObject!) {
    setUserPasswordMutation(input: $input) {
      response {
        id
        status
        code
        message
      }
    }
  }
`;

export const UPDATE_MY_PROFILE_MUTATION = gql`
  mutation updateMyProfileMutation($input: UpdateProfileInputObject!) {
    updateMyProfileMutation(input: $input) {
      response {
        ${responseField}
      }
      data {
        ${userFields}
      }
    }
  }`;

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation forgotPasswordMutation($email: String!) {
    forgotPasswordMutation(email: $email) {
      response {
        ${responseField}
      }
    }
  }`;

export const ACTIVATE_OR_RESET_PASSWORD_MUTATION = gql`
  mutation activateOrResetPasswordMutation($input: SetOrResetPasswordInputObject) {
    activateOrResetPasswordMutation(input: $input) {
      response {
        ${responseField}
      }
    }
  }`;


export const CHANGE_PASSWORD_MUTATION = gql`
  mutation changePasswordMutation($input: ChangePasswordInputObject!) {
    changePasswordMutation(input: $input) {
      response {
        ${responseField}
      }
    }
  }`;

export const ACTIVATE_OR_DEACTIVATE_USER_MUTATION = gql`
  mutation ActivateOrDeactivateUserMutation($input: ActivateOrDeactivateUserInput!) {
    activateOrDeactivateUserMutation(input: $input) {
      data {
        ${userFields}
      }
      response {
        ${responseField}
      }
    }
  }`;
